<div class="settings-tab-container">
  <table role="presentation">
    <tr><td colspan="2"><div class="settings-header">Formatting</div></td></tr>
    <tr>
      <td><div class="settings-item-label">Date Format:</div></td>
      <td>
        <div class="settings-item">
          <kendo-dropdownlist id="general_dateformat" style="width:250px"
                              [data]="dateformats" textField="text" valueField="value"
                              (valueChange)="dateValueChange($event,'general_dateformat')"
                              [(ngModel)]="settingsModel.dateFormat"></kendo-dropdownlist>
        </div>
      </td>
    </tr>
  </table>


</div>
